import api from '@/api/app'
const mine = {
  mine: {
    viewInfo: {
      obj: {

      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {

    }
  },
  set: {
    viewInfo: {
      obj: {
        tabs: [
          {
            id: 111,
            key: 0,
            name: '学校信息',
            type: 'text'
          },
          {
            id: 222,
            key: 1,
            name: '教师信息',
            type: 'text'
          },
          {
            id: 333,
            key: 2,
            name: '功能室信息',
            type: 'text'
          },
          {
            id: 444,
            key: 3,
            name: '班级信息',
            type: 'text'
          }
        ],
        userRules: {
          name: [
            {
              required: true, message: '请输入姓名', trigger: 'blur'
            }
          ],
          remark: [
            {
              required: true, message: '请输入备注', trigger: 'blur'
            }
          ]
        },
        funRules: {
          name: [
            {
              required: true, message: '请输入名称', trigger: 'blur'
            }
          ],
          info: [
            {
              required: true, message: '请输入介绍', trigger: 'blur'
            }
          ]
        },
        wxRules: {
          phone: [
            {
              required: true, message: '请输入手机号', trigger: 'blur'
            }
          ],
          captcha: [
            {
              required: true, message: '请输入图片验证码', trigger: 'blur'
            }
          ],
          code: [
            {
              required: true, message: '请输入验证码', trigger: 'blur'
            }
          ]
        },
        phoneEditRules: {
          phone: [
            {
              required: true, message: '请输入原手机号', trigger: 'blur'
            }
          ],
          captcha: [
            {
              required: true, message: '请输入图片验证码', trigger: 'blur'
            }
          ],
          code: [
            {
              required: true, message: '请输入验证码', trigger: 'blur'
            }
          ],
          phone1: [
            {
              required: true, message: '请输入新手机号', trigger: 'blur'
            }
          ]
        },
        gradeRules: {
          name: [
            {
              required: true, message: '请输入名称', trigger: 'blur'
            }
          ],
          remark: [
            {
              required: true, message: '请输入备注', trigger: 'blur'
            }
          ]
        },
        table1: [
          {
            type: 'text',
            model: 'name',
            label: '姓名',
            width: '200',
            align: 'center'
          },
          {
            type: 'text',
            model: 'remark',
            label: '备注',
            width: '',
            align: 'center'
          },
          // {
          //   type: 'slot',
          //   model: 'wx',
          //   label: '微信',
          //   width: '200',
          //   align: 'center'
          // },
          {
            type: 'slot',
            model: 'operate',
            label: '操作',
            width: '',
            align: 'center'
          }
        ],
        table2: [
          {
            type: 'text',
            model: 'name',
            label: '名称',
            width: '200',
            align: 'center'
          },
          {
            type: 'text',
            model: 'info',
            label: '备注',
            width: '200',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'teacher_name',
            label: '负责人',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'created_date',
            label: '创建时间',
            width: '200',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'operate',
            label: '操作',
            width: '',
            align: 'center'
          }
        ],
        table3: [
          {
            type: 'text',
            model: 'name',
            label: '名称',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'remark',
            label: '备注',
            width: '',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'operate',
            label: '操作',
            width: '',
            align: 'center'
          }
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [],
      data1: (v) => {
        return new Promise((resolve) => {
          api.mine.retrieve.user(v).then((res) => {
            resolve(res.data)
          })
        })
      },
      data2: (v) => {
        return new Promise((resolve) => {
          api.mine.retrieve.room(v).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      data3: (v) => {
        return new Promise((resolve) => {
          api.school.retrieve.dto(v).then((res) => {
            resolve(res.data[0])
          })
        })
      },
      data4: (v) => {
        return new Promise((resolve) => {
          api.mine.retrieve.grade(v).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      handleCheckImg: () => {
        return new Promise((resolve) => {
          api.system.captcha().then((res) => {
            resolve(res.data)
          })
        })
      }
    }
  },
  collect: {
    viewInfo: {
      obj: {
        tabsList: [
          {
            id: 2,
            key: 0,
            name: '优秀案例空间',
            type: 'text'
          },
          {
            id: 1,
            key: 1,
            name: '标准化应用空间',
            type: 'text'
          },
          {
            id: 3,
            key: 2,
            name: '标准文库',
            type: 'text'
          }
        ],
        table: [

          {
            type: 'text',
            model: 'number',
            label: '标准编号',
            width: '',
            align: 'center'
          },
          {
            type: 'text',
            model: 'article_name',
            label: '标准名称',
            width: '',
            align: 'center'
          },
          {
            type: 'slot',
            model: 'operate',
            label: '操作',
            width: '',
            align: 'center'
          }
        ]
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      url: (obj) => {
        return new Promise((resolve) => {
          api.square.update.dto(obj).then((res) => {
            resolve(res.data.url)
          })
        })
      },
      data2: (obj) => {
        return new Promise((resolve) => {
          api.mine.retrieve.collect(obj).then((res) => {
            res.data.data.map(item => {
              item.cover_pic = item.img_url
            })
            resolve(res.data.data)
          })
        })
      },
      data1: (obj) => {
        return new Promise((resolve) => {
          api.mine.retrieve.collect(obj).then((res) => {
            resolve(res.data.data)
          })
        })
      }
    }
  },
  course: {
    viewInfo: {
      obj: {
        week: ['日', '一', '二', '三', '四', '五', '六'],
        rules: {
          name: [
            {
              required: true, message: '请输入姓名', trigger: 'blur'
            }
          ],
          remark: [
            {
              required: true, message: '请输入备注', trigger: 'blur'
            }
          ]
        }
      },
      data: {

      }
    },
    control: {
      /**
             * 当前操作 是否是编辑用户
             * @date 2021-04-23
             * @param {any} condition //条件数组
             * @returns {any}
             */
      isEdit: (condition) => {
        return condition[0] == 2
      }
    },
    init: {
      initConfigs: [],
      data1: (v) => {
        return new Promise((resolve) => {
          api.mine.retrieve.course(v).then((res) => {
            if (res.data.length) {
              res.data.map((item, index) => {
                item.id = index + 1
                if (item.child.length) {
                  item.child.map(itn => {
                    itn.sum = `${itn.student_count}人`
                    itn.disable = false
                  })
                }
              })
            }
            resolve(res.data)
          })
        })
      },
      data2: (v) => {
        return new Promise((resolve) => {
          api.mine.retrieve.room(v).then((res) => {
            if (res.data.data.length) {
              res.data.data.map((item, index) => {
                item.type = 'text'
                item.key = index
              })
            }
            resolve(res.data.data)
          })
        })
      },
      data3: (v) => {
        return new Promise((resolve) => {
          api.mine.retrieve.grade(v).then((res) => {
            resolve(res.data.data)
          })
        })
      },
      data4: (v) => {
        return new Promise((resolve) => {
          api.mine.retrieve.user(v).then((res) => {
            resolve(res.data)
          })
        })
      }
    }
  }
}
export default mine
